module.exports = __webpack_public_path__ + "img/t_q4.4afa339e.jpeg";